import { createFileRoute } from '@tanstack/react-router'
import LeadDetailPage from '@/pages/leads/lead-detail'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

// Rota index para /dashboard/$dashboardId/leads/$leadId
// Renderizada quando acessar diretamente /dashboard/$dashboardId/leads/$leadId
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/leads/$leadId/',
)({
  component: function LeadDetailRoute() {
    const { dashboardId, leadId } = Route.useParams()
    return (
      <ProtectedRoute
        anyOf={[CAPABILITIES.LEADS_ALL, CAPABILITIES.LEADS_OWN]}
        dashboardId={dashboardId}
      >
        <LeadDetailPage leadId={leadId} dashboardId={dashboardId} />
      </ProtectedRoute>
    )
  },
})
